let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lqbZ7")).then(() => parcelRequire('6l3q7'));